/* eslint-disable jira/filename-case */
import type { CollectionUUID } from '@jira/polaris__domain-collection/src/SrcViewResponse.tsx';
import type { JiraProjectAri } from '@atlassian/ari/jira/project';

type ProjectId = string;
type ProjectKey = string;

export const PolarisEnvironmentContainerTypes = {
	PROJECT: 'PROJECT',
	VIEW: 'VIEW',
	COLLECTION: 'COLLECTION',
} as const;

type BasePolarisEnvironmentContainer = {
	id: string;
};

type ViewId = string;

type PolarisProjectContainer = BasePolarisEnvironmentContainer & {
	type: typeof PolarisEnvironmentContainerTypes.PROJECT;
	projectId: ProjectId;
	projectKey: ProjectKey;
	projectAri: JiraProjectAri;
};

type PolarisCollectionContainer = BasePolarisEnvironmentContainer & {
	type: typeof PolarisEnvironmentContainerTypes.COLLECTION;
	collectionId: CollectionUUID;
};

type PolarisViewContainer = BasePolarisEnvironmentContainer & {
	type: typeof PolarisEnvironmentContainerTypes.VIEW;
	viewId: ViewId;
	projectId?: ProjectId;
};

export type PolarisEnvironmentContainer =
	| PolarisProjectContainer
	| PolarisCollectionContainer
	| PolarisViewContainer;

export type ContainerId = ProjectId | CollectionUUID | ViewId;
